import React, { Component } from "react";
import { Button, Dropdown, Grid, Modal, Header, Icon } from 'semantic-ui-react'
import axios from "axios";


interface JobDropDown {
  id: number;
  value: number;
  text: string;
  description: string;
}

var url = "https://encontech.azurewebsites.net/api/jobs";
//var url = "http://localhost:5000/api/jobs";



class AdminDeleteJob extends Component {
  state = {
    jobData:new Array<JobDropDown>(),
    selectValue:0,
    open:false,
    deleteJobText: "",
    disableDelete:true
  };

  componentDidMount() {

    axios.get(url).then((response) => {

      var delJobList = response.data.map((x:any) => {
        return  { key: x.id, value: x.id, text: x.name, description: x.address}
      });

      this.setState({
        jobData: delJobList,
      });
    });
  }

  handleChange = (e:any, { value }: any ) => {
    console.log(value);
    console.log(this.state.jobData);
    var index = this.state.jobData.findIndex(x => x.value === value );

    this.setState({ 
      selectValue:value,
      deleteJobText: this.state.jobData[index].text + " ( " + this.state.jobData[index].description + " )",
      disableDelete:false
    });
    
  }

  removeJob = (e: any) => {

    console.log("removing job: " + this.state.selectValue)
    axios
    .delete(url+ "/" + this.state.selectValue)
    .then(res => {
      this.setState({
        jobData: this.state.jobData.filter( (x:JobDropDown) => { return x.id != this.state.selectValue}),
        open : false
      });
    })
    .catch(err => {
      console.log(err);
    }); 

    this.setState({
      jobData: this.state.jobData.filter( (x:JobDropDown) => { return x.value != this.state.selectValue}),
      open : false,
      disableDelete:true
    });
  }
 
  
  render() {

    return (
    <div style={{ height:"500px" }}>
        <h1>Admin (Delete Job Site)</h1>
    <Grid columns={2} padded>
        <Grid.Row>
            <Grid.Column width={14}>
            <Dropdown
              placeholder='Select Job Site to Delete..'
              fluid
              search
              selection
              options={this.state.jobData}
              value={this.state.selectValue} 
              onChange={this.handleChange.bind(this)} 
            />
            </Grid.Column>
            <Grid.Column width={2}>
            
            
            <Modal
      basic
      onClose={() => this.setState({open : false})}
      onOpen={() => this.setState({open : true})}
      open={this.state.open}
      size='small'
      trigger={<Button primary disabled={this.state.disableDelete} >Delete</Button>}
    >
      <Header icon color="red" >
        <Icon name='trash' />
        Are you sure you want to delete this job site?
      </Header>
      <Modal.Content >
        <h2 >
          {this.state.deleteJobText }
        </h2>
      </Modal.Content>
      <Modal.Actions>
        <Button color='red' inverted onClick={() =>this.setState({open : false})}>
          <Icon name='remove' /> No
        </Button>
        <Button color='green' inverted onClick={this.removeJob.bind(this)}>
          <Icon name='checkmark' /> Yes
        </Button>
      </Modal.Actions>
    </Modal>

            </Grid.Column>
        </Grid.Row>
    </Grid>
    </div>
  )
  }
  }
  export default AdminDeleteJob